/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import TourInserterConfiguration from 'embercom/objects/series/node/tour-inserter-configuration';

export default class TourNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new TourInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
